<template>
  <div slot="activator">
    <slot
      name="activator"
      :label="label"
      :text="text"
      :prepend-icon="prependIcon"
      :append-icon="appendIcon"
      :open="open"
    >
      <DefaultFilterActivator
        :value="text"
        :label="label"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        @clear="$emit('clear')"
      />
    </slot>
  </div>
</template>

<script setup>
import DefaultFilterActivator from "#ce/apps/shared/filters/components/DefaultFilterActivator.ce.vue";

defineEmits(["clear"]);

defineProps({
  label: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    default: undefined,
  },
  prependIcon: {
    type: String,
    default: undefined,
  },
  appendIcon: {
    type: String,
    default: undefined,
  },
  open: {
    type: Boolean,
    default: false,
  },
});
</script>
